// 网黑料 · 首页静态语料（本地展示用）

export interface Story {
  id: number;
  tag: string; // 分区标签
  status: string; // 事件状态：新爆出 / 当事人回应 / 核实中 / 持续关注
  title: string;
  summary: string;
  time: string;
  heat: number; // 热度值
  read: string;
  image?: string;
}

export interface ImageLinkStory extends Story {
  cover: string;
}

// 顶部「快讯 LIVE」滚动更新条
export const liveTicker = [
  '头部带货机构供应链抽成争议发酵 三家平台同日落表回应',
  '某网红餐饮"联名套餐"供应商重叠 定价差被网友逐项比对',
  '电竞选手转会条款疑现"阴阳合同" 联盟宣布介入核查',
  '选秀节目选手旧账号言论被重新考古 制作方称将统一说明',
  '母婴品牌被曝客服离职率畸高 一段内部会议录音在网上流传',
  '打赏榜单疑似混入"刷量机器人"账号 公会抽成规则引热议',
  '高端茶饮"周年联名"翻车 从预热到道歉不足 72 小时',
  '健身博主被指引流课程与实际授课不符 学员集体晒退款截图',
];

// 首屏头条大卡
export const heroFeature: ImageLinkStory = {
  id: 1001,
  tag: '今日头条',
  status: '持续关注',
  title: '头部直播机构供应链抽成被质疑"两头吃" 多平台同日回应 事件仍在发酵',
  summary:
    '一份流传的招商口径与部分合作方提供的结算单出入明显，抽成比例、账期与"垫资款"是否真进供应商账户成为焦点。目前已有三家平台及至少五家上游供应商先后表态，说法不一，矛盾点集中在同一组对账数字上。',
  time: '今天 09:12 更新',
  heat: 9860,
  read: '128.4万热度',
  cover:
    'https://readdy.ai/api/search-image?query=Editorial%20investigative%20newsroom%20scene%20shot%20from%20a%20slight%20angle%2C%20a%20clear%20magnifying%20glass%20resting%20over%20a%20stack%20of%20paper%20documents%20spreadsheets%20and%20receipts%20on%20a%20clean%20desk%2C%20some%20circled%20with%20red%20ink%20annotations%20and%20newspaper%20clippings%2C%20warm%20paper%20tones%20with%20dark%20ink%20and%20one%20muted%20crimson%20highlight%2C%20dramatic%20soft%20side%20light%2C%20shallow%20depth%20of%20field%2C%20crisp%20professional%20press%20photography%20composition%2C%20calm%20restrained%20mood&width=1200&height=675&seq=blackinfo-hero-01&orientation=landscape',
};

// 首屏右侧抢先看
export const heroSide: ImageLinkStory[] = [
  {
    id: 1002,
    tag: '企业',
    status: '当事人回应',
    title: '网红餐饮"联名套餐"被扒供应商重叠 同料不同价引质疑',
    summary: '网友晒出两份套餐配料表与进货价，差价焦点集中在"品牌溢价"的归处。',
    time: '今天 08:40',
    heat: 5210,
    read: '6.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Closeup%20product%20photography%20of%20a%20takeout%20meal%20box%20with%20a%20small%20receipt%20and%20price%20tag%20beside%20it%20on%20a%20neutral%20table%2C%20ingredient%20list%20paper%20visible%2C%20warm%20subtle%20light%2C%20clean%20minimal%20editorial%20food%20scene%2C%20soft%20shadows%2C%20high%20detail%2C%20restrained%20and%20calm%20composition&width=600&height=450&seq=blackinfo-ht-01&orientation=landscape',
  },
  {
    id: 1003,
    tag: '文娱',
    status: '新爆出',
    title: '选秀节目选手旧账号言论被"考古" 多条历史动态逐帧截图流传',
    summary: '截图跨越多个月份，真伪与语境成讨论焦点，节目组被喊话回应。',
    time: '今天 07:55',
    heat: 4780,
    read: '5.1万',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20smartphone%20screen%20showing%20a%20social%20media%20post%20being%20screenshot%2C%20hand%20holding%20the%20phone%20over%20a%20dark%20muted%20desk%2C%20screen%20glow%20with%20subtle%20warm%20tone%2C%20cinematic%20shallow%20focus%2C%20modern%20digital%20culture%20news%20feel%2C%20clean%20and%20calm%20composition&width=600&height=450&seq=blackinfo-ht-02&orientation=landscape',
  },
];

// 今日新料（时间线式速览，无封面）
export const todayFeed: Story[] = [
  {
    id: 2001,
    tag: '直播',
    status: '核实中',
    title: '头部主播"护盘直播"数据遭第三方平台对账 高峰峰值与录屏不符',
    summary: '第三方榜单给出的同时在线峰值，与主播直播间公开录屏口径对不上，平台尚未出具官方说明。',
    time: '今天 11:03',
    heat: 8930,
    read: '93.7万',
  },
  {
    id: 2002,
    tag: '餐饮',
    status: '各方说法',
    title: '网红餐饮"联名套餐"供应商重叠 定价差被网友逐项比对',
    summary: '同一家代工厂同时出现在两款定价相差近一倍的套餐配料表上，溢价去向成话题。',
    time: '今天 10:26',
    heat: 7160,
    read: '61.2万',
  },
  {
    id: 2003,
    tag: '文娱',
    status: '当事人回应',
    title: '综艺选手旧账号言论被重新考古 制作方称将统一对外说明',
    summary: '多张历史动态截图在站内流传，制作方表示已介入核实发布语境，避免误读。',
    time: '今天 09:48',
    heat: 6020,
    read: '44.8万',
  },
  {
    id: 2004,
    tag: '电竞',
    status: '联盟介入',
    title: '转会条款疑现"阴阳合同" 双方合同细节差异被逐条截图',
    summary: '流出版本与俱乐部公示的转会费、年限均不一致，联盟已发函要求提供完整材料。',
    time: '今天 09:05',
    heat: 5450,
    read: '38.3万',
  },
  {
    id: 2005,
    tag: '消费',
    status: '新爆出',
    title: '母婴品牌被曝试用期客服离职率畸高 内部会议录音片段流出',
    summary: '录音中关于"考核话术"与"差评处理"的描述，被在职与离职员工双口径交叉印证。',
    time: '今天 08:16',
    heat: 4010,
    read: '27.9万',
  },
];

// 猛料速报（横版大卡，起底向）
export const explosiveFeed: ImageLinkStory[] = [
  {
    id: 3001,
    tag: '猛料起底',
    status: '完整复盘',
    title: '昔日"赔付承诺"账目首度被完整复盘 同一批口径对出三倍差额',
    summary: '把承诺文告、客服口径与最终打款记录逐一对齐，发现同一场事件在不同平台留下三套说法，其中差额接近三倍。完整账目脉络已梳理成图。',
    time: '昨天 21:30',
    heat: 12050,
    read: '156.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Professional%20editorial%20photograph%20of%20an%20accountant%20reviewing%20ledger%20books%20and%20printed%20spreadsheets%20on%20a%20desk%20with%20a%20calculator%20and%20a%20red%20pen%2C%20some%20pages%20marked%20with%20red%20checks%20and%20question%20marks%2C%20warm%20paper%20tones%20and%20dark%20ink%20accents%2C%20soft%20window%20light%2C%20high%20detail%2C%20calm%20investigative%20finance%20journalism%20composition&width=1400&height=640&seq=blackinfo-explosive-01&orientation=landscape',
  },
  {
    id: 3002,
    tag: '猛料起底',
    status: '关联起底',
    title: '励志"人设"背后 关联公司五年注销七家 清算记录被逐条扒出',
    summary: '从公开工商记录反推，"创业励志"叙事与背后公司走向存在明显时间差。股权、法人变更与注销时点被整理成一张脉络图。',
    time: '昨天 19:12',
    heat: 9840,
    read: '88.6万',
    cover:
      'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20still%20life%20of%20a%20cracked%20mirror%20reflection%20symbolizing%20a%20public%20image%20in%20question%2C%20fragmented%20silhouette%20and%20a%20few%20official%20documents%20scattered%20in%20foreground%2C%20dark%20moody%20tones%20with%20a%20single%20warm%20amber%20highlight%2C%20high%20contrast%20shadows%2C%20conceptual%20press%20photography%2C%20restrained%20and%20clean&width=1400&height=640&seq=blackinfo-explosive-02&orientation=landscape',
  },
  {
    id: 3003,
    tag: '猛料速报',
    status: '核实中',
    title: '打赏榜单现"刷量机器人"账号 公会抽成潜规则浮出水面',
    summary: '多位从业者晒出同批账号的行为轨迹截图，打赏节奏高度一致。平台表示正在核查名单并升级风控模型。',
    time: '昨天 16:40',
    heat: 7660,
    read: '59.3万',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dim%20room%20showing%20a%20live%20streaming%20donation%20interface%20with%20rocket%20gift%20icons%20and%20rising%20rank%20numbers%2C%20blurred%20room%20background%2C%20cinematic%20low%20light%20with%20warm%20highlights%2C%20high%20detail%2C%20modern%20digital%20news%20feel%2C%20clean%20composition&width=1400&height=640&seq=blackinfo-explosive-03&orientation=landscape',
  },
];

// 事件内幕：72 小时时间线
export const timelineStory = {
  tag: '事件内幕',
  status: '复盘完成',
  title: '一盒联名茶的 72 小时：从高调预热到连夜道歉，关键节点逐帧还原',
  summary: '我们把这次联名翻车事件里公开的推文、公告与客服记录，按时间顺序重新摆上桌，还原每一步决策如何把热度推向争议。',
  items: [
    {
      time: 'D0 · 08:00',
      title: '官宣预热，限量 9999 盒',
      detail: '首发文案强调"限定联名、售完即止"，联动多个渠道同步造势。',
    },
    {
      time: 'D0 · 20:30',
      title: '开售即"秒空"，黄牛价翻倍',
      detail: '首批链接上线后快速售罄，二手平台随即出现高价转卖，引发对真实库存的疑问。',
    },
    {
      time: 'D1 · 10:00',
      title: '配料表流出，口径开始分化',
      detail: '联名款与常规款被指共用代工与原料，品牌客服解释前后不一致。',
    },
    {
      time: 'D2 · 23:40',
      title: '连夜致歉并开放退款通道',
      detail: '品牌发布长文致歉，承认物料口径表述不当，开放无理由退款并给出补偿方案。',
    },
  ],
};

// 热门话题榜
export const hotTopics = [
  { rank: 1, title: '直播供应链抽成争议', heat: '186万 在讨论', delta: '↑ 12%' },
  { rank: 2, title: '联名茶"同料不同价"', heat: '142万 在讨论', delta: '新上榜' },
  { rank: 3, title: '打赏"刷量机器人"核查', heat: '98万 在讨论', delta: '↑ 8%' },
  { rank: 4, title: '电竞转会"阴阳合同"', heat: '76万 在讨论', delta: '↑ 5%' },
  { rank: 5, title: '励志人设背后的注销记录', heat: '63万 在讨论', delta: '↑ 3%' },
  { rank: 6, title: '母婴品牌内部录音', heat: '51万 在讨论', delta: '↓ 2%' },
];

// 投稿入口步骤
export const reportSteps = [
  { step: '01', title: '整理素材', desc: '把截图、录屏、时间线归拢到一处，信息越完整越利于核实。' },
  { step: '02', title: '匿名投递', desc: '可选留联系邮箱用于跟进，其余信息不会对外公开。' },
  { step: '03', title: '多方核实', desc: '编辑组交叉比对来源与口径，能自证的才进入公开流程。' },
];

// 信任与 FAQ
export const faqs = [
  {
    q: '更新这么密集，来源可靠吗？',
    a: '我们把"谁说的、何时说、原始出处"作为默认字段一起呈现，每条新料都会标注状态标签。能给出原始出处的信息会优先排序，孤证会单独标记，不做默认定论。',
  },
  {
    q: '"核实中"和"当事人回应"有什么区别？',
    a: '前者指多方信息仍在交叉比对、尚未形成一致结论；后者指涉事一方或平台已公开发声。两者都不是最终结论，我们会在状态变化时持续跟进。',
  },
  {
    q: '如果当事人澄清，你们会处理吗？',
    a: '会。任何一方通过公开渠道给出的有效澄清或更正，都会被单独成条、连同原脉络一并展示，避免"只爆不更"。',
  },
  {
    q: '我是否也可以在这里发声或投稿？',
    a: '可以。页面下方设有投稿入口，素材经编辑组核实后才会进入公开流程；涉及个人隐私或明显越界的信息会被过滤。',
  },
];

export const trustPrinciples = [
  '只标可核实出处，不把孤证当结论',
  '状态随时更新，澄清与更正同等展示',
  '涉及个人隐私的信息一律不予公开',
  '避免预设立场，欢迎双方提供证据',
];